export default __webpack_public_path__ + "static/media/third.cfdd7ebd.svg";